import { Link } from '@backstage/core-components';
import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { ReactNode, useContext } from 'react';
import { SidebarConfig, WbSidebarConfigContext } from '../../config';
import { useWbSidebarOpenState } from '../../WbSidebarOpenStateContext';
import { Logo } from './Logo';
import { useWbSidebarMobileState } from '../../WbNavbarMobileStateContext';

type WbSidebarLogoProps = {
  renderLogo?: (isOpen: boolean) => ReactNode;
  to: string;
};

const useStyle = makeStyles<Theme, SidebarConfig>(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80px',
  },
  drawerWidth: props => ({
    width: props.drawerWidthClosed,
  }),
  drawerOpen: props => ({
    width: props.drawerWidthOpen,
    padding: '2px 12px',
  }),
  mobile: () => ({
    height: '32px',
    padding: '2px 4px',
  }),
}));

export const WbSidebarLogo = ({ renderLogo, to }: WbSidebarLogoProps) => {
  const { isOpen } = useWbSidebarOpenState();
  const { isMobile } = useWbSidebarMobileState();
  const { sidebarConfig } = useContext(WbSidebarConfigContext);

  const classes = useStyle(sidebarConfig);

  if (renderLogo) return <>{renderLogo(isOpen)}</>;
  return (
    <Link
      className={clsx(
        classes.root,
        classes.drawerWidth,
        isOpen && classes.drawerOpen,
        isMobile && classes.mobile,
      )}
      underline="none"
      aria-label="Home"
      to={to}
    >
      <Logo full={isOpen} hidePoweredBy={isMobile} />
    </Link>
  );
};
